const ATTRIBUTION_KEY = 'crinoAttribution';
const ATTRIBUTION_TTL_DAYS = 90;

const TRACKED_PARAMS = [
  'gclid',
  'gbraid',
  'wbraid',
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
];

function safeParseJSON(value) {
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
}

function cleanParam(value) {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  return trimmed ? trimmed.slice(0, 300) : null;
}

function readStoredAttribution(now = Date.now()) {
  if (typeof window === 'undefined') return {};
  const raw = window.localStorage.getItem(ATTRIBUTION_KEY);
  const parsed = raw ? safeParseJSON(raw) : null;
  if (!parsed?.expiresAt || parsed.expiresAt < now) return {};
  return parsed;
}

export function captureAttributionFromUrl() {
  if (typeof window === 'undefined') return {};

  const now = Date.now();
  const current = readStoredAttribution(now);
  const params = new URLSearchParams(window.location.search);
  const next = { ...current };
  let changed = false;

  for (const key of TRACKED_PARAMS) {
    const value = cleanParam(params.get(key));
    if (value) {
      next[key] = value;
      changed = true;
    }
  }

  if (!next.firstLandingPage) {
    next.firstLandingPage = window.location.href.slice(0, 1000);
    changed = true;
  }

  next.lastLandingPage = window.location.href.slice(0, 1000);
  if (document.referrer) next.referrer = document.referrer.slice(0, 1000);

  if (changed) {
    next.capturedAt = new Date(now).toISOString();
  }
  next.updatedAt = new Date(now).toISOString();
  next.expiresAt = now + ATTRIBUTION_TTL_DAYS * 24 * 60 * 60 * 1000;

  try {
    window.localStorage.setItem(ATTRIBUTION_KEY, JSON.stringify(next));
  } catch {
    // localStorage can be unavailable in strict browser modes.
  }

  return next;
}

export function getStoredAttribution() {
  if (typeof window === 'undefined') return {};
  return readStoredAttribution();
}
